<template>
  <v-dialog
    :value="value"
    max-width="560"
    persistent
    @input="$emit('input', $event)"
  >
    <div class="rv">
      <h3>Откатить импорт{{ item && item.fileName ? ' «' + item.fileName + '»' : '' }}?</h3>
      <p class="rv-sub">
        Каждый филиал партии вернётся к состоянию до импорта. Всё, что менялось в этих филиалах после, тоже отменится.
      </p>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        class="rv-progress"
      />
      <div v-else class="rv-list">
        <div v-for="p in plans" :key="p.filialId" class="rv-filial">
          <div class="rv-filial-name">
            {{ filialName(p.filialId) }}
          </div>
          <div v-if="isEmpty(p)" class="rv-filial-same">
            уже совпадает с версией до импорта
          </div>
          <div v-else class="rv-filial-counts">
            {{ countsText(p) }}
          </div>
          <div
            v-for="(w, i) in p.warnings"
            :key="i"
            class="rv-warn"
            :class="w.code"
          >
            {{ warningText(w) }}
          </div>
        </div>
      </div>
      <div v-if="error" class="rv-error">
        {{ error }}
      </div>
      <div class="rv-actions">
        <button
          type="button"
          class="btn-cancel"
          :disabled="saving"
          @click="$emit('input', false)"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn-apply"
          :disabled="loading || saving || !plans.length || allEmpty"
          @click="$emit('confirm')"
        >
          {{ saving ? 'Откатываем…' : 'Откатить' }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { planCounts, warningText, isPlanEmpty } from './restorePlanText'

  /** Подтверждение отката партии импорта: план по каждому филиалу партии. */
  export default {
    name: 'RestoreImportDialog',
    props: {
      value: { type: Boolean, default: false },
      item: { type: Object, default: null },
      plans: { type: Array, default: () => [] },
      filials: { type: Array, default: () => [] },
      loading: { type: Boolean, default: false },
      saving: { type: Boolean, default: false },
      error: { type: String, default: '' },
    },
    computed: {
      allEmpty () {
        return this.plans.every(isPlanEmpty)
      },
    },
    methods: {
      warningText,
      isEmpty: isPlanEmpty,
      countsText (p) {
        return planCounts(p)
          .filter((c) => c.key !== 'unchanged' && c.value)
          .map((c) => `${c.label} ${c.value}`)
          .join(', ')
      },
      filialName (id) {
        const f = this.filials.find((x) => x.id === id)
        return f ? [f.address || f.name, f.city].filter(Boolean).join(', ') : '#' + id
      },
    },
  }
</script>

<style scoped src="./restore-dialog.css"></style>
